// Internal Module Imports
import { HttpClient } from '../utils/httpClient';
import { formatStartDateStringMoment } from '../utils/timeHelper';
import { formatEndDateStringMoment } from '../utils/timeHelper';

const PATH = {
    data: '/admin/data/fcr-d-minus',
    getLastBid: '/admin/data/fcr-d-minus/last',
    postBid: '/admin/data/fcr-d-minus/createBid',
    checkBidStatus: '/admin/data/fcr-d-minus/checkbid',
    addResultId: '/admin/data/fcr-d-minus/addResultId',
    biddingTool: 'admin/data/fcr-d-minus/bidding-tool',
    createReverseBid: '/admin/data/fcr-d-minus/reverse',
    UpdatePercentage: 'admin/data/fcr-d-minus/update-percentage',
    UpdateDMinusOne: 'admin/data/fcr-d-minus/d-one',
    marketEnabledGroups: 'admin/data/FCR-D-DEC/market-enabled-groups',
    bidRequest: '/admin/data/bid-request/FCR-D-DEC',
    deleteBidRequest: '/admin/data/bid-request',
    forceActivation: '/admin/data/force-activation',
    instanceDetails: '/admin/data/intance-details',
    maintenanceHours: '/admin/data/maintenance-hours/FCR-D-DEC',
    deleteMaintenanceHours: '/admin/data/maintenance-hours',
    bidsExport: '/admin/data/bids/export',
    totalCapacity: '/admin/data/bids/total-capacity',
};

export const formatedEndDate = (date) => {
    return `${formatEndDateStringMoment(date)}`;
};

export const formatedStartDate = (date) => {
    return `${formatStartDateStringMoment(date)}`;
};

const Create = (params, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.data}`, payload, { params }).then(callback).catch(error).finally(next);
};

const PostBid = (id, params, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.postBid}/${id}`, payload, { params }).then(callback).catch(error).finally(next);
};

const BidData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.data, { params }).then(callback).catch(error).finally(next);
};

const GetLastBid = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getLastBid}`, { params }).then(callback).catch(error).finally(next);
};

const CheckBidStatus = (id, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.checkBidStatus}/${id}`).then(callback).catch(error).finally(next);
};

const Delete = (_id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.data}?_id=${_id}`).then(callback).catch(error).finally(next);
};

const AddResultId = (id, data, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.addResultId}/${id}`, data).then(callback).catch(error).finally(next);
};

const GetBiddingToolData = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.biddingTool}`).then(callback).catch(error).finally(next);
};

const UpdatePercentage = (data, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.UpdatePercentage}`, data).then(callback).catch(error).finally(next);
};

const UpdateDMinusOne = (id, data, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.UpdateDMinusOne}/${id}`, data).then(callback).catch(error).finally(next);
};

const GetMarketEnabledGroups = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.marketEnabledGroups}`).then(callback).catch(error).finally(next);
};

const ForceActivation = (params, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.forceActivation}`, params).then(callback).catch(error).finally(next);
};

const GetInstanceDetails = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.instanceDetails}/${id}`).then(callback).catch(error).finally(next);
};

const GetBidRequestForADate = (params, groupId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bidRequest}/${groupId}`, { params }).then(callback).catch(error).finally(next);
};

const GetBidRequests = (params = {}, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bidRequest}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteBidRequest = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteBidRequest}/${id}`).then(callback).catch(error).finally(next);
};

const GetMaintenanceHours = (params = {}, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.maintenanceHours}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteMaintenanceHours = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.deleteMaintenanceHours}/${id}`).then(callback).catch(error).finally(next);
};

const GetMaintenanceHoursForADate = (params, groupId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.maintenanceHours}/${groupId}`, { params }).then(callback).catch(error).finally(next);
};

const BidsExport = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.bidsExport}`, { params }).then(callback).catch(error).finally(next);
};

const BidCapacity = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.totalCapacity}`, { params }).then(callback).catch(error).finally(next);
};

const CreateReverseBid = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.createReverseBid}/${id}`, payload).then(callback).catch(error).finally(next);
};

export const FcrDMinusBidService = {
    BidData,
    Create,
    Delete,
    GetLastBid,
    PostBid,
    CheckBidStatus,
    AddResultId,
    GetBiddingToolData,
    UpdatePercentage,
    UpdateDMinusOne,
    GetMarketEnabledGroups,
    GetBidRequestForADate,
    GetBidRequests,
    DeleteBidRequest,
    ForceActivation,
    GetInstanceDetails,
    GetMaintenanceHours,
    DeleteMaintenanceHours,
    GetMaintenanceHoursForADate,
    BidsExport,
    BidCapacity,
    CreateReverseBid,
};
